/** @format */

import axios from "axios";
import { useState } from "react";
import Resume from "../settings/resume.json";
import url from "../settings/settings.json";

// const [profile, setProfile] = useState([]);

const names = Resume.basics.name.split(" ");

// let fullName;

// async function get() {
//   const fetchData = await axios.get(url.API_URI, {
//     headers: {
//       authorization: "Bearer JWT Token",
//     },
//   });

//   console.log(fetchData);
//   fullName = fetchData.data[0]?.fullName;
//   console.log(fullName);
//   setProfile(fullName);
// }

// get();
// console.log(fullName);
// console.log(profile);
export const FirstName = names[0];

export const LastName = names[names.length - 1];

export const Initials = FirstName.charAt(0)
  .toUpperCase()
  .concat(LastName.charAt(0).toUpperCase());

export const getObject = (dataArray, textToFind) => {
  const object = dataArray?.find((obj) => obj.name === textToFind);
  return object;
};
